<template>
  <div id="cart" class="full_layout cart" v-loading.fullscreen="loading">
    <div v-if="!isNull&&list!=null">
      <div class="cartTitle">
        <h3>购物车<span>共{{count}}件商品</span></h3>
        <span class="delAll" @click="delAllCart">清空购物车</span>
      </div>
      <div class="cart_list_title cart_list">
        <el-checkbox class="cart_list_checkbox" :isIndeterminate='isIndeterminate' v-model="checkAll" @change="handleCheckAllChange"></el-checkbox>
        <div class="cart_list_products">商品</div>
        <div class="cart_list_detail">详情</div>
        <div class="cart_list_price">单价</div>
        <div class="cart_list_number">数量</div>
        <div class="cart_list_total">总价</div>
      </div>
      <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
        <div class="cart_list" v-for="(item,index) in list" :key="index">
          <el-checkbox class="cart_list_checkbox" :disabled="item.Status!=1?true:false" :label="item">
          </el-checkbox>
          <div class="cart_list_checkbox_detail">
            <div class="cart_list_products">
              <router-link class="cart_img" :to="{path:'/market/item/'+item.CommodityId+'?type=1'}">
                <img :src="item.TitImg+'?imageView2/2/w/160'">
              </router-link>
              <span class="hotTag" v-if="item.Status==2">即将上架</span>
            </div>
            <div class="cart_list_detail space_between">
              <router-link :to="{path:'/market/item/'+item.CommodityId+'?type=1'}">
                <p class="line_txt3">{{item.Title}}</p>
              </router-link>
              <span class="del" @click="delCart(item)">删除</span>
            </div>
            <div class="cart_list_price">
              <del v-if="item.LowestPrice!=item.Price&&item.Status!=2">￥{{item.Price.toLocaleString()}}</del>
              <span class="price_red" v-if="item.LowestPrice!=item.Price&&item.Status!=2">￥{{item.LowestPrice.toLocaleString()}}</span>
              <span v-if="item.LowestPrice==item.Price&&item.Status!=2">￥{{item.Price.toLocaleString()}}</span>
              <span v-if="item.LowestPrice!=item.Price&&item.Status==2">￥{{item.Price.toLocaleString()}}</span>
            </div>
            <div class="cart_list_number">
              <el-input-number v-model="item.Num" :disabled="item.Status==2?true:false" @change="handleChange(item,index)" :min="1" :max="item.error!=''?qty:item.Num"></el-input-number>
              <span class="error" v-if="item.error!=''">{{item.error}}</span>
            </div>
            <div class="cart_list_total">
              <span v-if="item.Status==1">￥{{(item.LowestPrice*item.Num).toLocaleString()}}</span>
              <span v-if="item.Status==2">￥{{(item.Price*item.Num).toLocaleString()}}</span>
            </div>
          </div>
        </div>
      </el-checkbox-group>
      <!-- invalidList!=null -->
      <div class="cart_list discard" v-for="(item,index) in invalidList" :key="index" v-if="invalidList!=null">
        <div class="cart_list_checkbox"> </div>
        <div class="cart_list_products">
          <router-link class="cart_img" :to="{path:'/market/item/'+item._id+'?type=1'}">
            <img :src="item.TitImg">
          </router-link>
          <span class="error">该商品已售空</span>
        </div>
        <div class="cart_list_detail space_between">
          <router-link :to="{path:'/market/item/'+item._id+'?type=1'}">
            <p class="line_txt3">{{item.Title}}</p>
          </router-link>
          <span class="del" @click="delCart(item)">删除</span>
        </div>
        <div class="cart_list_price">
          <span>￥{{item.Price.toLocaleString()}}</span>
        </div>
        <div class="cart_list_number">
          <el-input-number v-model="item.Num" :disabled='true' :min="item.Num" :max="item.Num" label=""></el-input-number>
        </div>
        <div class="cart_list_total">
          <span>￥{{(item.Price*item.Num)}}</span>
        </div>
      </div>
      <div class="subTotalBox">
        <div class="subTotal">
          <div class="space_between">
            <span>总价</span>
            <span class="price">{{countCart(checkedCities,0)}}</span>
          </div>
          <div class="space_between">
            <span>数量</span>
            <span class="">{{countCart(checkedCities,3)}}件</span>
          </div>
          <div class="space_between" v-if="countCart(checkedCities,2)>0">
            <span>优惠</span>
            <span class='price price_red'>{{countCart(checkedCities,2)}}</span>
          </div>
          <div class="space_between total">
            <span>共计</span>
            <span class='price'>{{countCart(checkedCities,1)}}</span>
          </div>
          <el-button class='subtn' type="primary" :disabled="disabled" @click="goToPay(checkedCities)">结算</el-button>
        </div>
      </div>
    </div>
    <nonull type='cart' text="您的购物车还没有添加商品" v-if="isNull" />
  </div>
</template>
<script>
import { getInfo, numAdd, numSub, numMulti } from "@/api/public";
import Nonull from '@/components/nonull'
export default {
  name: 'cart',
  components: { Nonull },
  data() {
    return {
      
      qty:process.env.vue_WEB_NUM,//可以加入购物车的数量上限
      disabled: true,
      loading: false,
      userInfo: getInfo(),
      list: null,
      invalidList: null,
      count: 0,
      isNull: false,
      checkedCities: [],
      checkAll: false,
      isIndeterminate: false,
      num: 1
    }
  },
  mounted() {},
  created() {
    this.GetMyCartList()
  },
  methods: {
    GetMyCartList() {
      let that = this;
      that.loading = true;
      let data = { MemberId: that.userInfo._id, PageIndex: 1, PageSize: 99 };
      that.$get(that.$interface.GetMyCartPageList, data).then(res => {
        if (res.Result != 0) {
          that.isNull = res.Count > 0 ? false : true;
          that.count = res.Count;
          that.list = res.Data;
          if (!that.isNull) {
            let newlist = [];
            let hotlist = [];
            let invalid = [];
            res.Data.map(it => {
              it.error = null;
              if (it.Status == 1) {
                newlist.push(it)
              } else if (it.Status == 2) {
                hotlist.push(it)
              } else {
                invalid.push(it)
              }
            })
            newlist = [...newlist, ...hotlist]
            that.list = newlist
            that.invalidList = invalid
          } else {
            that.isNull = true;
            that.loading = false;
          }
        } else {
          that.isNull = true;
        }
        that.loading = false;
      }).catch({})
    },
    // 计算购物车价格  type 0:总价，1:共计，2:优惠,3:数量
    countCart(obj, type) {
      let inall = 0
      let reduction = 0
      let total = 0
      let num = 0
      if (obj.length > 0) {
        this.disabled = false;
        obj.map(res => {
          inall += numMulti(res.Price, res.Num)
          total += numMulti(res.LowestPrice, res.Num)
          num = numAdd(num, res.Num)
        })
        if (type == 0) {
          return inall.toLocaleString()
        }
        if (type == 1) {
          return total.toLocaleString()
        }
        if (type == 2) {
          return numSub(inall, total).toLocaleString()
        }
        if (type == 3) {
          return num
        } else {
          return 0
        }
      } else {
        this.disabled = true;
        return 0
      }
    },
    goToPay(obj) {
      let that = this
      this.disabled = true;
      let newDetail = [];
      let error = null;
      obj.map(res => {
        if (res.error != '') {
          error = res.error
        }
        newDetail.push({
          CommodityId: res.CommodityId,
          CreateDate: res.CreateDate,
          LowestPrice: res.LowestPrice,
          Num: res.Num,
          Price: res.Price,
          TitImg: res.TitImg,
          Title: res.Title,
          _id: res._id
        })
      })
      console.log('error', error)
      if (error == '' || error == null) {
        let data = {
          isCrat: 1,
          Details: newDetail
        };
        window.sessionStorage.setItem('dakacheck', JSON.stringify(data))
        that.$router.push({ path: '/checkout' })
      } else {
        that.$message.error(error);
        that.GetMyCartList();
        that.disabled = false;
      }
    },
    handleChange(obj, val) {
      let that = this
      that.loading = true;
      let data = { commodityId: obj.CommodityId, num: obj.Num, memberId: that.userInfo._id, type: false }
      that.$post(that.$interface.AddMyCart, data).then(res => {
        if (res.Result != 0) {
          that.list[val]['Num'] = obj.Num
        } else {
          that.list[val]['Num'] = obj.Num
          that.list[val]['error'] = res.Msg
        }
        that.loading = false;
      })
    },
    // 全选
    handleCheckAllChange(val) {
      var list = [];
      this.list.map(it => {
        if (it.Status == 1) {
          list.push(it)
        }
      })
      this.checkedCities = val ? list : [];
      this.isIndeterminate = false;
    },
    // 单选
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.list.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length;
    },
    // 删除购物车
    delCart(obj) {
      let that = this

      this.$confirm('确定删除该商品吗？', '', {
        lockScroll: false,
        customClass: 'alert alertCart',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        that.loading = true;
        let data = { id: obj._id, memberId: obj.MemeberId }
        that.$post(that.$interface.DeleteMyCart, data).then(res => {
          if (res.Result != 0) {
            that.checkedCities=[]
            that.checkAll=false
            that.GetMyCartList()
          } else {
            that.$message.error(res.Msg);
            that.loading = false;
          }
          that.loading = false;
        })
      })
    },
    delAllCart() {
      let that = this;
      this.$confirm('确定清空购物车？', '', {
        lockScroll: false,
        customClass: 'alert alertCart',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        that.loading = true;
        let data = { memberId: that.userInfo._id };
        that.$post(that.$interface.DeleteMyCartAll, data).then(res => {
          if (res.Result != 0) {
            that.checkedCities=[]
            that.checkAll=false
            that.GetMyCartList()
            that.$root.$emit("newCart", "false");
          } else {
            that.$message.error(res.Msg);
            that.loading = false;
          }
          that.loading = false;
        })
      })
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/pay.css";

</style>



// WEBPACK FOOTER //
// src/pages/pay/cart.vue